import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { fetchCart } from '@/services/cart';
import { Cart } from '@/types/cart';

export const useCartQuery = (
  { bonusesUsed = 0 } = {},
  config: Omit<UseQueryOptions<Cart, Error, Cart>, 'queryKey' | 'queryFn'> = {}
): UseQueryResult<Cart> => {
  return useQuery<Cart>({
    queryKey: ['cart', { bonusesUsed }],
    queryFn: () => fetchCart(bonusesUsed),
    ...config,
  });
};
